import app from 'flarum/forum/app';
import Page from 'flarum/forum/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Tooltip from 'flarum/common/components/Tooltip';
import Button from 'flarum/common/components/Button';
import icon from 'flarum/common/helpers/icon';
import listItems from 'flarum/common/helpers/listItems';
import username from 'flarum/common/helpers/username';
import highlight from 'flarum/common/helpers/highlight';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import EditUserModal from 'flarum/common/components/EditUserModal';
import SuspendUserModal from 'flarum/suspend/components/suspendUserModal';

// flarum.core.compat['kilowhat/audit/components/AuditModal']
//import AuditModal from 'flarum/kilowhat/audit/components/AuditModal';

//import ProfileUserCard from './ProfileUserCard';

import CreateUserModal from '../components/CreateUserModal';
import EditUserApplicationsModal from '../components/EditUserApplicationsModal';
import GlobalApplicationControlModal from '../components/GlobalApplicationControlModal';
import GenerateApplicationKeysModal from '../components/GenerateApplicationKeysModal';

export default class CheatpanelPage extends Page  {
    oninit(vnode) {
        super.oninit(vnode);

        app.history.push('cheatpanel', icon('fas fa-crosshairs'));

        app.setTitle( app.translator.trans('xtreh-phoenix.forum.cheatpanel.label'));
        app.setTitleCount(0);

        this.offset = 0;
        this.limit = Math.min(24, Math.ceil(($(window).height() - 150) / 50) & ~1);
        this.query = '';
        this.users = app.store.all('users').slice(0, this.limit);
        this.totalUsers = this.users.length;
        this.isLoadingPage = false;

        this.searchState = {
            cached: new Map(),
            timeout: null,
            /**
             * @type function
             */
            search: function (query, offset, limit, callback) {
                const key = [ query, offset, limit ].join('-');
                if (this.cached.has(key)) {
                    callback && callback(this.cached.get(key));
                    return;
                }

                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    app.store.find('users', { filter: { q: query }, page: { offset, limit } }).then((results) => {
                        this.cached.set(key, results);
                        this.search(query, offset, limit, callback);
                        m.redraw();
                    })
                }, 250);
            },
            /**
             * @type function
             */
            clear: function (query, offset, limit) {
                if (query === undefined && offset === undefined && limit === undefined)
                    this.cached.clear();
                else {
                    const key = [ query, offset, limit ].join('-');
                    this.cached.delete(key);
                }
            }
        };

        this.load();
    }

    view() {
        const users = this.users;

        const columns = this.columns().toArray();

        const controls = new ItemList();

        controls.add(
            'create_user',
            <Button className="Button CheatpanelPage-createUserBtn" icon="fas fa-user-plus" onclick={() => app.modal.show(CreateUserModal, { onsuccess: () => this.load() })}>
                {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.create_user_button')}
            </Button>
        );

        if ('kilowhat-audit' in flarum.extensions) {
            app.forum.attribute('canViewAudit') && controls.add(
                'audit',
                <Button className="Button CheatpanelPage-auditBtn" icon="fas fa-history" onclick={() => app.modal.show(flarum.core.compat['kilowhat/audit/components/AuditModal'], { onsuccess: () => this.load() })}>
                    {app.translator.trans('kilowhat-audit.forum.modal.label')}
                </Button>
            );
        }

        app.forum.attribute('canEditApplications') && controls.add(
            'global_application_control',
            <Button className="Button CheatpanelPage-globalAppCtrlBtn" icon="fas fa-globe" onclick={() => app.modal.show(GlobalApplicationControlModal, { onsuccess: () => this.load() })}>
                {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.global_control.button')}
            </Button>
        );

        app.forum.attribute('canCreateApplicationKeys') && controls.add(
            'generate_application_keys',
            <Button className="Button CheatpanelPage-genAppKeysBtn" icon="fas fa-key" onclick={() => app.modal.show(GenerateApplicationKeysModal, { onsuccess: () => this.load() })}>
                {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.generate_keys.button')}
            </Button>
        );

        return (
            <div className="CheatpanelPage">
                <div className='CheatpanelPage-header'>
                    <h4 className='App-titleControl App-titleControl--text'> { app.translator.trans('xtreh-phoenix.forum.cheatpanel.label') }</h4>
                </div>
                <div className='CheatpanelPage-content'>
                    <div className="Search">
                        <div className="Search-input">
                            <input
                                className="FormControl SearchUsers"
                                type="search"
                                placeholder={app.translator.trans('xtreh-phoenix.forum.cheatpanel.search_placeholder')}
                                value={this.query}
                                oninput={(event) => { this.offset = 0; this.query = event?.target?.value; this.queryList(); } }
                            />
                            {
                                this.query && <Button
                                    className='Search-clear Button Button--icon Button--link'
                                    onclick={() => {
                                        this.query = '';
                                        this.queryList();
                                    }}
                                    icon='fas fa-times-circle'
                                />
                            }
                        </div>
                        <span class='item-totalusers'>{app.translator.trans('xtreh-phoenix.forum.cheatpanel.total_users', { total: this.totalUsers })}</span>
                    </div>
                    <div className="Controls">
                        { controls.toArray() }
                    </div>
                    <div className="Users">
                        <section
                            className={classList(['CheatpanelPage-grid', this.isLoadingPage ? 'CheatpanelPage-grid--loadingPage' : 'CheatpanelPage-grid--loaded'])}
                            style={{ '--columns': columns.length }}
                            role="table"
                            // +1 to account for header
                            aria-rowcount={users.length + 1}
                            aria-colcount={columns.length}
                            aria-live="polite"
                            aria-busy={this.isLoadingPage ? 'true' : 'false'}
                        >
                            {/* Render columns */}
                            {
                                columns.map((column, colIndex) => (
                                    <div className="CheatpanelPage-grid-header" role="columnheader" aria-colindex={colIndex + 1} aria-rowindex={1}>
                                        {column.name}
                                    </div>
                                ))
                            }

                            {/* Render user data */}
                            {
                                users.map((user, rowIndex) =>
                                    columns.map((col, colIndex) => {
                                        const columnContent = col.content && col.content(user), columnTooltip = { tooltipVisible: col.tooltip?undefined:false, ...(col.tooltip && col.tooltip(user)) };
                                        return (
                                            <Tooltip { ...columnTooltip }>
                                                <div
                                                    className={classList(['CheatpanelPage-grid-rowItem', rowIndex % 2 > 0 && 'CheatpanelPage-grid-rowItem--shaded'])}
                                                    data-user-id={user.id()}
                                                    data-column-name={col.itemName}
                                                    aria-colindex={colIndex + 1}
                                                    // +2 to account for 0-based index, and for the header row
                                                    aria-rowindex={rowIndex + 2}
                                                    role="cell"
                                                >
                                                    {columnContent}
                                                </div>
                                            </Tooltip>
                                        );
                                    })
                                )
                            }

                            {/* Loading spinner that shows when a new page is being loaded */}
                            {this.isLoadingPage && <LoadingIndicator size='large' />}
                        </section>
                        <nav className="CheatpanelPage-gridPagination">
                            <Button
                                disabled={this.offset === 0}
                                title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.pagination.first_button')}
                                onclick={() => { this.offset = 0; this.queryList(); } }
                                icon="fas fa-step-backward"
                                className="Button Button--icon CheatpanelPage-firstPageBtn"
                            />
                            <Button
                                disabled={this.offset === 0}
                                title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.pagination.back_button')}
                                onclick={() => { this.offset = Math.max(this.offset - this.limit, 0); this.queryList(); } }
                                icon="fas fa-chevron-left"
                                className="Button Button--icon CheatpanelPage-backBtn"
                            />
                            <span className="CheatpanelPage-pageNumber">
                                {this.offset + 1}-{Math.max(this.offset + 1, Math.min(this.offset + this.limit, this.totalUsers))}
                            </span>
                            <Button
                                disabled={(this.offset + this.limit) >= this.totalUsers}
                                title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.pagination.next_button')}
                                onclick={() => { this.offset = Math.min(this.offset + this.limit, this.totalUsers); this.queryList(); } }
                                icon="fas fa-chevron-right"
                                className="Button Button--icon CheatpanelPage-nextBtn"
                            />
                            <Button
                                disabled={(this.offset + this.limit) >= this.totalUsers}
                                title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.pagination.last_button')}
                                onclick={() => { this.offset = this.totalUsers - this.limit; this.queryList(); } }
                                icon="fas fa-step-forward"
                                className="Button Button--icon CheatpanelPage-lastPageBtn"
                            />
                        </nav>
                    </div>
                </div>
            </div>
        );
    }

    columns() {
        const columns = new ItemList();

        columns.add(
            'id',
            {
                name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.user_id'),
                content: (user) => user.id()
            },
            100
        );

        columns.add(
            'username',
            {
                name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.username.label'),
                content: (user) => {
                    const profileUrl = `${app.forum.attribute('baseUrl')}/u/${user.slug()}`;
                    return (
                        <a
                            target="_blank"
                            href={profileUrl}
                            title={extractText(app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.username.tooltip', { username: username(user) }))}
                        >
                            {this.getUsernameHighlighted(user)}
                        </a>
                    );
                }
            },
            90
        );

        columns.add(
            'lastSeenTime',
            {
                name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.last_seen_time'),
                content: (user) => {
                    const lastSeenTime = user.lastSeenAt() || user.joinTime();
                    return (
                        user.lastSeenAt() && user.isOnline() ?
                        <span className='UserCard-lastSeen online' title={extractText(app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.online.tooltip', { username: username(user) }))}>
                            { icon('fas fa-circle') }
                            { ' ' }
                            { app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.online.label') }
                        </span> :
                        <span className="CheatpanelUserList-lastSeenTime" title={lastSeenTime}>
                            { dayjs(lastSeenTime).format('LLL') }
                        </span>
                    )
                }
            },
            80
        );

        columns.add(
            'groupBadges',
            {
                name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.group_badges'),
                content: (user) => {
                    const badges = user.badges().toArray();
                    if (badges.length) {
                        return <ul className="DiscussionHero-badges badges">{listItems(badges)}</ul>;
                    } else {
                        return app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.no_badge');
                    }
                }
            },
            70
        );

        columns.add(
            'applications',
            {
                name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.applications.label'),
                content: (user) => (
                    <Button
                        className="Button Button--transparent CheatpanelUserList-editModalBtn"
                        title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.applications.tooltip', { username: username(user) })}
                        icon='fas fa-th'
                        onclick={() => app.modal.show(EditUserApplicationsModal, { user: user, onsuccess: () => this.load() })}
                        disabled={!user.canEditApplications()}
                    >
                        {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.applications.button')}
                    </Button>
                )
            },
            -90
        );

        columns.add(
            'profile',
            {
                name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.profile.label'),
                content: (user) => (
                    <Button
                        className="Button Button--transparent CheatpanelUserList-editModalBtn"
                        title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.profile.tooltip', { username: username(user) })}
                        icon='fas fa-user'
                        onclick={() => app.modal.show(EditUserModal, { user })}
                        disabled={!user.canEdit() && !user.canEditCredentials() && !user.canEditGroups()}
                    >
                        {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.profile.button')}
                    </Button>
                )
            },
            -110
        );

        if ('flarum-suspend' in flarum.extensions) {
            columns.add(
                'suspend',
                {
                    name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.suspend.label'),
                    content: (user) => (
                        <Button
                            className="Button Button--transparent CheatpanelUserList-editModalBtn"
                            title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.suspend.tooltip', { username: username(user) })}
                            icon='fas fa-ban'
                            onclick={() => app.modal.show(SuspendUserModal, { user: user })}
                            disabled={!user.canSuspend()}
                        >
                            {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.suspend.button')}
                        </Button>
                    )
                },
                -130
            );
        }

        columns.add(
            'delete',
            {
                name: app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.delete.label'),
                content: (user) => (
                    <Button
                        className="Button Button--danger CheatpanelUserList-editModalBtn"
                        title={app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.delete.tooltip', { username: username(user) })}
                        icon='fas fa-times'
                        onclick={() => {
                            if (confirm(extractText(app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.delete.confirmation')))) {
                                user.delete().then(() => this.load());
                            }
                        }}
                        disabled={!user.canDelete()}
                    >
                        {app.translator.trans('xtreh-phoenix.forum.cheatpanel.grid.delete.button')}
                    </Button>
                )
            },
            -150
        );

        return columns;
    }

    load() {
        this.searchState.clear(this.query, this.offset, this.limit);
        this.queryList();
    }

    queryList() {
        this.isLoadingPage = true;
        this.searchState.search(this.query, this.offset, this.limit, (users) => {
            this.users = users;
            this.totalUsers = users.payload.meta.modelStatistics['users'].total;
            this.isLoadingPage = false;
        })
    }

    getUsernameHighlighted(user) {
        const name = (user && user.displayName()) || extractText(app.translator.trans('core.lib.username.deleted_text'));
        const children = highlight(name, this.query);
        return <span className="username">{children}</span>;
    }
}
